import { render, staticRenderFns } from "./SelectPlatform.vue?vue&type=template&id=390e5132&scoped=true&"
import script from "./SelectPlatform.vue?vue&type=script&lang=js&"
export * from "./SelectPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390e5132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
